import { stringify } from 'qs';
import * as environment from './environmentURL';
class URLData {
    constructor(params) {
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "brand", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lang", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_publicAPIBaseURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_ssoBackendURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getLocalizedPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path = '') => {
                if (path !== '') {
                    if (this.lang !== 'et' && !this.pathContainsLocale(path)) {
                        return this.localizedPath.concat(path);
                    }
                    return path;
                }
                return this.localizedPath;
            }
        });
        Object.defineProperty(this, "getBrandFreeURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path = '') => {
                return this.brandFreeURL.concat(path);
            }
        });
        Object.defineProperty(this, "getPublicURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path = '') => {
                return this.publicURL.concat(path);
            }
        });
        Object.defineProperty(this, "getPublicLink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path = '') => {
                if (this.app !== 'public') {
                    if (path !== '') {
                        if (this.pathContainsLocale(path) || path.includes(`/${this.lang}`)) {
                            return this.publicBaseURL.concat(path);
                        }
                        return this.publicURL.concat(path);
                    }
                    return this.publicURL;
                }
                return this.pathContainsLocale(path) ? path : this.getLocalizedPath(path);
            }
        });
        Object.defineProperty(this, "getSelfServiceURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path) => {
                return this.selfServiceURL.concat(path ? path : '');
            }
        });
        Object.defineProperty(this, "getFrontlineURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path) => {
                return this.frontlineBaseURL.concat(path ? path : '');
            }
        });
        Object.defineProperty(this, "getSelfServiceLink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path = '') => {
                if (!['selfservice', 'frontline'].includes(this.app)) {
                    if (path !== '') {
                        if (this.pathContainsLocale(path)) {
                            return this.selfServiceBaseURL.concat(path);
                        }
                        return this.selfServiceURL.concat(path);
                    }
                    return this.selfServiceURL;
                }
                return this.pathContainsLocale(path) ? path : this.getLocalizedPath(path);
            }
        });
        Object.defineProperty(this, "getShopLink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path = '') => {
                if (this.app !== 'shop') {
                    if (path !== '') {
                        return `${this.shopBaseURL}${path}?lang=${this.lang}`;
                    }
                    return this.shopURL;
                }
                return this.pathContainsLocale(path) ? path : this.getLocalizedPath(path);
            }
        });
        Object.defineProperty(this, "getSegmentLink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (segment) => {
                const isTelia = this.brand === 'telia';
                switch (segment) {
                    case 'private':
                        return this.getPublicLink(this.getLocalizedPath(isTelia ? '/era' : '/'));
                    case 'business':
                        return this.getPublicLink(this.getLocalizedPath(isTelia ? '/ari' : '/'));
                    case 'selfservice':
                        return this.getSelfServiceLink(this.getLocalizedPath('/'));
                    case 'shop':
                        return this.getShopLink();
                }
            }
        });
        Object.defineProperty(this, "defaultSsoUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (loginOptions) => {
                return `${this.ssoBackendURL}?${stringify({ webapi: true, ...loginOptions })}`;
            }
        });
        Object.defineProperty(this, "ssoBackendLink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (loginOptions) => {
                const authlevel = loginOptions.authLevel;
                const ssoParams = { ...loginOptions };
                delete ssoParams.authLevel;
                return `${this.ssoBackendURL}?${stringify({ authlevel, ...ssoParams })}`;
            }
        });
        Object.defineProperty(this, "getDealerMenuUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return `${this.portalSupportAPIBaseURL}/menu/dealer/main`;
            }
        });
        Object.defineProperty(this, "getResolveMenuURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (menuParams) => {
                return `${this.portalSupportAPIBaseURL}/menu/resolve?${stringify(menuParams)}`;
            }
        });
        Object.defineProperty(this, "getResolveFrontlineMenuURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (menuParams) => {
                return `${this.portalSupportAPIBaseURL}/menu/dealer/resolve?${stringify(menuParams)}`;
            }
        });
        Object.defineProperty(this, "getTranslationsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lang = this.lang) => {
                return `${this.portalSupportAPIBaseURL}/translations/${lang}?appNames=global`;
            }
        });
        Object.defineProperty(this, "getSearchSuggestionsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (queryString, clientType) => {
                return `${environment.getSearchAPIBaseUrl(this.tier)}/common/v2/suggestions?lang=${this.lang}&query=${queryString}&clientType=${clientType}`;
            }
        });
        Object.defineProperty(this, "getDealerSearchSuggestionsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return `${environment.getSearchAPIBaseUrl(this.tier)}/dealer/search-history`;
            }
        });
        Object.defineProperty(this, "getSearchEventURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return `${environment.getSearchAPIBaseUrl(this.tier)}/common/event`;
            }
        });
        Object.defineProperty(this, "getNotificationsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path) => {
                return `${environment.getAPIBaseURL(this.tier, this.brand)}${path}`;
            }
        });
        Object.defineProperty(this, "getFooterColumnsURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (lang = this.lang) => {
                return `${this.portalSupportAPIBaseURL}/footer/${lang}?brand=${this.brand}`;
            }
        });
        Object.defineProperty(this, "pathContainsLocale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path) => {
                if (!path) {
                    return false;
                }
                return path.startsWith('/ru/') || path === '/ru' || path.startsWith('/et/') || path === '/et' || path.startsWith('/en/') || path === '/en';
            }
        });
        this.app = params.app;
        this.brand = params.brand;
        this.tier = params.tier;
        this.lang = params.lang;
        this._publicAPIBaseURL = params.apiBaseURL;
        this._ssoBackendURL = params.ssoBackendURL;
    }
    get brandFreeBaseURL() {
        return environment.getBrandFreeURL(this.tier);
    }
    get selfServiceBaseURL() {
        if (this.brand === 'super') {
            return `${environment.getPublicURL(this.tier, this.brand)}/${this.lang}/self`;
        }
        return environment.getSelfServiceURL(this.tier, this.brand);
    }
    get frontlineBaseURL() {
        return `${environment.getSelfServiceURL(this.tier, 'telia')}/teenindus`;
    }
    get publicBaseURL() {
        return environment.getPublicURL(this.tier, this.brand);
    }
    get onlineHelpBaseURL() {
        return environment.getOnlineHelpURL(this.tier);
    }
    get minuTvBaseURL() {
        return environment.getMinuTvURL(this.tier);
    }
    get shopBaseURL() {
        return environment.getShopURL(this.tier);
    }
    get getApp() {
        return this.app;
    }
    get localizedPath() {
        return this.lang !== 'et' && this.app !== 'shop' ? `/${this.lang}` : '';
    }
    get brandFreeURL() {
        return this.brandFreeBaseURL.concat(this.localizedPath);
    }
    get selfServiceURL() {
        return this.selfServiceBaseURL.concat(this.localizedPath);
    }
    get publicURL() {
        return this.publicBaseURL.concat(this.localizedPath);
    }
    get onlineHelpURL() {
        return this.onlineHelpBaseURL.concat(this.localizedPath);
    }
    get minuTvURL() {
        return this.minuTvBaseURL.concat(this.localizedPath);
    }
    get shopURL() {
        return `${this.shopBaseURL}?lang=${this.lang}`;
    }
    get portalSupportAPIBaseURL() {
        return this._publicAPIBaseURL != null ? this._publicAPIBaseURL : environment.getAPIBaseURL(this.tier, this.brand);
    }
    get commonAPIBaseURL() {
        return environment.getCommonAPIBaseURL(this.tier);
    }
    get ssoBackendURL() {
        return this._ssoBackendURL != null ? this._ssoBackendURL : environment.getSSOBackendURL(this.tier, this.brand);
    }
    getAddressEventsURL(addressId, buildingId, roomId) {
        if (this.app === 'frontline') {
            return `/frontline-api/address-events?addressId=${addressId}&buildingId=${buildingId}&roomId=${!roomId ? '' : roomId}`;
        }
        return `${this.selfServiceBaseURL}/frontline-api/address-events?addressId=${addressId}&buildingId=${buildingId}&roomId=${!roomId ? '' : roomId}`;
    }
    getNewAddressEventUrl(addressId, buildingId, roomId) {
        if (this.app === 'frontline') {
            return `/teenindus/aadressi-syndmuse-lisamine/${addressId}/${buildingId}${!roomId ? '' : `/${roomId}`}`;
        }
        return `${this.frontlineBaseURL}/aadressi-syndmuse-lisamine/${addressId}/${buildingId}${!roomId ? '' : `/${roomId}`}`;
    }
}
export default URLData;
//# sourceMappingURL=URLData.js.map